import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { UitkSpacingSpaces, UitkSpacingSpacesBreaks } from 'uitk-react-spacing/dist/types';

import { classNames } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';

export interface StrikeoutPriceProps {
  strikeOut?: string;
  wrapPrice?: boolean;
}

export const StrikeoutPrice: React.FunctionComponent<StrikeoutPriceProps> = ({ strikeOut, wrapPrice }) => {
  const classes = classNames('uitk-cell uitk-type-300 pwa-theme--grey-700', {
    'all-cell-shrink': !wrapPrice,
    'm-cell-shrink l-cell-shrink xl-cell-shrink': wrapPrice,
  });
  const paddingProps: UitkSpacingSpaces | UitkSpacingSpacesBreaks = wrapPrice
    ? // eslint-disable-next-line camelcase
      { inlinestart: 'half', medium: { inlineend: 'one' }, large: { inlineend: 'one' }, extra_large: { inlineend: 'one' } }
    : { inlinestart: 'half', inlineend: 'one' };

  return (
    <UitkSpacing padding={paddingProps}>
      <del className={`${classes}`} data-stid="content-hotel-strikeout-price">
        <span className="is-visually-hidden" data-stid="content-hotel-strikeout-price-a11y">
          <LocalizedText message="hotels.infosite.rateInfoDialog.strikeOut" data={[strikeOut]} />
        </span>
        <span data-stid="content-hotel-strikeout-price-visual" aria-hidden="true">
          {strikeOut}
        </span>
      </del>
    </UitkSpacing>
  );
};
